import React from 'react'

import styles from './styles.module.scss'

const Progress = ({label, value, pct}) => {
  return (
    <div className={styles.container}>
      <div className={styles.legend}>
        <div className={styles.label}>{label}</div>
        <div className={styles.value}>{value}</div>
      </div>
      <div className={styles.progress}>
        <div className={styles.track} style={{ transform: `translateX(-${100 - (pct || 0)}%)` }} />
      </div>
    </div>
  )
}

export default Progress
